import { Image, Skeleton } from '@chakra-ui/react';
import { useIconData } from 'hooks/useIcon';
import { useIcons8Thumbnail } from 'hooks/useIcons8Thumbnail';
import { memo } from 'react';

interface IconProps {
  iconId: string;
  thumbnailUrl?: string;
  isIcons8Illustration?: boolean;
  isIcons8?: boolean;
}

export const Icon = memo(({ iconId, isIcons8, thumbnailUrl, isIcons8Illustration }: IconProps) => {
  if (isIcons8) {
    return <Icons8Icon iconId={iconId} />;
  }

  if (isIcons8Illustration) {
    return <Icons8IllustrationIcon thumbnailUrl={thumbnailUrl!} />;
  }

  return <S3Icon iconId={iconId} />;
});
Icon.displayName = 'Icon';

const S3Icon = memo(({ iconId }: IconProps) => {
  const iconData = useIconData({ iconId });

  if (!iconData) {
    return null;
  }

  const { description, svg } = iconData;
  return (
    <Image
      src={`data:image/svg+xml;utf8,${encodeURIComponent(svg)}`}
      alt={description}
      w='full'
      h='full'
      objectFit='contain'
    />
  );
});
S3Icon.displayName = 'S3Icon';

interface Icons8IconProps {
  iconId: string;
}
const Icons8Icon = ({ iconId }: Icons8IconProps) => {
  const { data: thumbnailBlob } = useIcons8Thumbnail(iconId);

  if (!thumbnailBlob) {
    return <Skeleton w='full' h='full' opacity={0.5} />;
  }

  const thumbnailUrl = URL.createObjectURL(thumbnailBlob);
  return <Image src={thumbnailUrl} alt={iconId} w='full' h='full' objectFit='contain' pointerEvents='none' />;
};

interface Icons8IllustrationProps {
  thumbnailUrl: string;
}
const Icons8IllustrationIcon = ({ thumbnailUrl }: Icons8IllustrationProps) => {
  return <Image src={thumbnailUrl} w='full' h='full' objectFit='contain' pointerEvents='none' />;
};
